module.exports = __webpack_public_path__ + "img/CompAsia-logo.518ae1ab.png";